import { FC } from 'react'

const VideoCard: FC<{ videoId: string; height?: string | number; width?: string | number }> = ({
  videoId,
  width = '100%',
  height = 200,
}) => {
  return (
    <iframe
      width={width}
      height={height}
      src={`https://www.youtube.com/embed/${videoId}`}
      allow={'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'}
      referrerPolicy={'strict-origin-when-cross-origin'}
      allowFullScreen
    />
  )
}

export { VideoCard }
